import styled from "@emotion/styled";
import { tooltipClasses, Tooltip as MuiTooltip } from "@mui/material";
import React from "react";

const Tooltip = ({ title, children }) => {
  const CustomTooltipTheme = styled(({ className, ...props }) => (
    <MuiTooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#4971b2",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#4971b2",
    },
  }));
  return (
    <CustomTooltipTheme title={title} arrow className="custom-tooltip">
      {children}
    </CustomTooltipTheme>
  );
};

export default Tooltip;
